import { ListItemButton } from '@mui/material';

import { GDMListItemButtonComponent } from './GDMListItemButton.type';

/* TODO: Implement component using GDM default design */
const GDMListItemButton: GDMListItemButtonComponent = props => <ListItemButton {...props} />;

export default GDMListItemButton;
